import React, { Component } from 'react'
import { Loading } from '../../misc'
import {
    formHandler,
    Button,
    MultipleSelect,
    Select,
} from '../../ui'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as gearActions from '../../../actions/gear'

class LensSelectionForm extends Component {
    constructor(props) {
        super(props)

        this.state = { data: this.props.data }

        this.updateValue = formHandler.updateValue.bind(this)
    }

    componentWillMount() {
        if (! this.props.gear.lens_makes) {
            this.props.gearActions.loadLensMakes()
        }

        if (this.props.data.make) {
            this.props.gearActions.loadLensModels(this.props.data.make)
        }
    }

    _updateLensMake = (data) => {
        // when updating the lens make, load in the models associated to that make
        this.props.gearActions.loadLensModels(data.make)

        this.updateValue(data)
    }

    _submitLensData = () => {
        const data = {
            model: this.state.data.model && this.state.data.model.map((item) => item.value),
        }

        this.props.gearActions.submitLenses(
            data,
            this.props.crew_uuid,
            this.state.data.uuid
        )
    }

    render() {
        if (! this.props.gear.lens_makes) {
            return <Loading />
        }

        const errors = this.props.gear.errors

        let modelSelection = null

        const makeSelection = (
            <Select
                error={ errors.make }
                name="make"
                options={ this.props.gear.lens_makes }
                placeholder="Select lens make"
                updateValue={ this._updateLensMake }
                value={ this.state.data.make || '' }
            />
        )

        if (this.state.data.make && this.props.gear.lens_models) {
            modelSelection = (
                <div>
                    <p style={{ fontWeight: 'bold' }}>
                        If you own multiple lenses within the same brand, click all that apply. Search
                        by scrolling the list or manually typing in the model info. A checkmark next to
                        each lens will confirm its selection.
                    </p>
                    <p style={{ fontWeight: 'bold' }}>
                        All selected lenses will be listed directly under the "Select lens model" box.
                        Press SAVE and all listed lenses will added to your profile.
                    </p>
                    <MultipleSelect
                        error={ errors.model }
                        name="model"
                        options={ this.props.gear.lens_models || [] }
                        placeholder="Select lens model"
                        updateValue={ this.updateValue }
                        values={ this.state.data.model || [] }
                    />
                </div>
            )
        }

        return (
            <div>
                <p>
                    Can&apos;t find your make and model? Email&nbsp;
                    <a href="mailto:gear@hayden5.com">gear@hayden5.com</a> to tell us about your equipment type.
                </p>

                { makeSelection }
                { modelSelection }

                <Button
                    buttonOnly
                    loading={ this.props.appState.loading }
                    onClick={ this._submitLensData }
                    status="primary"
                >
                    Save
                </Button>
            </div>
        )
    }
}

LensSelectionForm.propTypes = {
    appState: React.PropTypes.object,
    crew_uuid: React.PropTypes.string,
    data: React.PropTypes.object,
    gear: React.PropTypes.object,
    gearActions: React.PropTypes.object,
}

export default connect(
    (state) => {
        return {
            appState: state.appState,
            gear: state.gear,
        }
    },
    (dispatch) => {
        return {
            gearActions: bindActionCreators(gearActions, dispatch),
        }
    }
)(LensSelectionForm)



// WEBPACK FOOTER //
// ./app/components/gear/modals/lens_selection_form.js